import { jsx as _jsx } from "react/jsx-runtime";
import { CrossSVG } from '@snack-uikit/icons';
import { TEST_IDS } from '../../constants';
import styles from './styles.module.css';
export function ButtonClose({ onClick }) {
    return (_jsx("button", { type: 'button', className: styles.buttonClose, onClick: onClick, "aria-label": 'close modal', "data-test-id": TEST_IDS.closeButton, children: _jsx(CrossSVG, {}) }));
}
